/**
 * SERAF — filtre tranches Izipizi sur la collection parent (sans navigation).
 */
const AGE_PARAM = 'age';
const HIDDEN_CLASS = 'seraf-izipizi-hidden';

function getGrid() {
  return document.querySelector('[data-ref="main-collection-grid"]');
}

function getNav() {
  return document.querySelector('[data-seraf-izipizi-nav]') || document.querySelector('.seraf-izipizi-nav');
}

function getPills() {
  const nav = getNav();
  if (!nav) return [];
  return nav.querySelectorAll('[data-seraf-izipizi-pill], .seraf-izipizi-nav__pills a, .seraf-izipizi-nav__pills button');
}

function getEmptyEl() {
  return document.querySelector('[data-seraf-izipizi-empty]');
}

function readAgeFromUrl() {
  return new URLSearchParams(window.location.search).get(AGE_PARAM) || '';
}

function ageFromHref(href) {
  if (!href) return '';
  const path = href.split('?')[0];
  if (path.endsWith('/les-lunettes-izipizi') || path.endsWith('/les-lunettes-izipizi/')) return '';
  if (path.includes('-kids-plus')) return 'kids+';
  if (path.includes('-baby')) return 'baby';
  if (path.includes('-junior')) return 'junior';
  if (path.includes('-kids')) return 'kids';
  return '';
}

function getCardAge(card) {
  const tagged = card.getAttribute('data-seraf-izipizi-age');
  if (tagged) return tagged;

  const url = card.getAttribute('data-product-url') || '';
  if (url.includes('-kids-plus')) return 'kids+';
  if (url.includes('-baby')) return 'baby';
  if (url.includes('-junior')) return 'junior';
  if (url.includes('-kids')) return 'kids';
  return '';
}

function getPillAge(pill) {
  if (pill.hasAttribute('data-seraf-izipizi-pill')) {
    return pill.getAttribute('data-seraf-izipizi-pill') || '';
  }
  if (pill.tagName === 'A') {
    return ageFromHref(pill.getAttribute('href') || '');
  }
  return '';
}

function setActivePill(ageKey) {
  getPills().forEach((pill) => {
    const pillAge = getPillAge(pill);
    const isActive = pillAge === ageKey;
    pill.classList.toggle('seraf-izipizi-nav__pill--active', isActive);
    pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    if (isActive) {
      pill.setAttribute('aria-current', 'true');
    } else {
      pill.removeAttribute('aria-current');
    }
  });
}

function updateUrl(ageKey) {
  const url = new URL(window.location.href);
  if (ageKey) {
    url.searchParams.set(AGE_PARAM, ageKey);
  } else {
    url.searchParams.delete(AGE_PARAM);
  }
  url.searchParams.delete('page');
  history.replaceState({}, '', url);
}

function applyIzipiziFilter(ageKey) {
  const grid = getGrid();
  if (!grid) return;

  let visible = 0;
  grid.querySelectorAll('product-card').forEach((card) => {
    const cardAge = getCardAge(card);
    const show = !ageKey || (cardAge !== '' && cardAge === ageKey);
    card.classList.toggle(HIDDEN_CLASS, !show);
    if (show) visible += 1;
  });

  const emptyEl = getEmptyEl();
  if (emptyEl) {
    emptyEl.hidden = visible > 0 || !ageKey;
  }

  setActivePill(ageKey);
  updateUrl(ageKey);
}

function onNavClick(event) {
  const pill = event.target.closest('[data-seraf-izipizi-pill], .seraf-izipizi-nav__pills a, .seraf-izipizi-nav__pills button');
  if (!pill || !pill.closest('.seraf-izipizi-nav__pills')) return;

  event.preventDefault();
  applyIzipiziFilter(getPillAge(pill));
}

let gridObserver = null;

function watchGrid() {
  const grid = getGrid();
  if (!grid || gridObserver) return;

  gridObserver = new MutationObserver(() => {
    const ageKey = readAgeFromUrl();
    if (ageKey) applyIzipiziFilter(ageKey);
  });
  gridObserver.observe(grid, { childList: true });
}

function initIzipiziFilter() {
  const nav = getNav();
  if (!nav || nav.dataset.serafIzipiziReady === 'true') return;
  if (!getGrid()) return;

  nav.dataset.serafIzipiziReady = 'true';
  nav.addEventListener('click', onNavClick);
  watchGrid();

  const initialAge = readAgeFromUrl();
  if (initialAge) {
    applyIzipiziFilter(initialAge);
  } else {
    setActivePill('');
  }

  document.addEventListener('filters:updated', () => {
    const ageKey = readAgeFromUrl();
    if (ageKey) applyIzipiziFilter(ageKey);
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target?.querySelector?.('.seraf-izipizi-nav, [data-seraf-izipizi-nav]')) {
      nav.dataset.serafIzipiziReady = 'false';
      gridObserver = null;
      initIzipiziFilter();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initIzipiziFilter);
} else {
  initIzipiziFilter();
}

window.serafApplyIzipiziFilter = applyIzipiziFilter;
